import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import './index.css'

// ✅ Configuração Balanceada do React Query
// Atualização inteligente via Socket.IO sem sobrecarregar o backend
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // ✅ 30 segundos - evita requisições excessivas
      cacheTime: 10 * 60 * 1000, // 10 minutos (mantém em cache)
      refetchOnWindowFocus: false, // ❌ Desabilitado - Socket.IO já atualiza
      refetchOnMount: false, // ❌ Desabilitado - Socket.IO já atualiza
      retry: 1, // Tentar novamente 1 vez em caso de erro
      keepPreviousData: true, // ✅ Manter dados anteriores durante carregamento (UX suave)
      refetchOnReconnect: true, // ✅ Refetch ao reconectar internet
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
